import React from "react";

const NotValidPath = () => {
  return <div>Not Valid Path</div>;
};

export default NotValidPath;
